import { useTranslate } from 'react-admin'
import { Box, Typography } from '@mui/material'
import EventIcon from '@mui/icons-material/Event'
import { blue } from 'src/assets/colors'
import { getDay } from '../../helper/getDay'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import { PERMISION_VIEW_CANCEL_SUPPLIER } from 'src/helper/Permission'

export const HotelCancellation = ({ autoCancelDate, cancellations }) => {
  const translate = useTranslate()

  const getCancellations = (title, items) => {
    if (items) {
      return (
        <>
          <Typography variant='h7' component='div' fontWeight={600}>
            {title}
          </Typography>
          <Box style={{ padding: '10px' }}>
            {items.map((cancellation, index) => (
              <Box className='cancellation_container' key={index}>
                <Box className='cancellation_column'>
                  <Typography variant='h7' component='div' fontWeight={600}>
                    {translate('ra.field.date')}:
                  </Typography>

                  <Typography variant='h7' component='div' className='cancellation_column_value'>
                    <EventIcon /> {getDay(cancellation?.date)}
                  </Typography>
                </Box>
                <Box className='cancellation_column'>
                  <Typography variant='h7' component='span' fontWeight={600}>
                    {translate('ra.field.amount')}:
                  </Typography>
                  <Typography variant='h7' component='div' className='cancellation_column_value'>
                    $ {cancellation?.amount}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </>
      )
    }
  }

  if (cancellations && cancellations.length !== 0) {
    return (
      <Box>
        <Typography variant='h6' component='div' color={blue} margin={'25px 0px 10px 0px'}>
          {translate('ra.title.cancellation_cost')}
        </Typography>
        {hasPermissionFunction('cancel-info', PERMISION_VIEW_CANCEL_SUPPLIER) &&
          getCancellations(
            translate('ra.title.cancellation_cost_provider'),
            cancellations.filter((elem) => !elem.is_client_cancel)
          )}
        {getCancellations(
          translate('ra.title.cancellation_cost_client'),
          cancellations.filter((elem) => elem.is_client_cancel)
        )}
        <ShowElement data={autoCancelDate} label={translate('ra.field.autocancel_date')} date />
      </Box>
    )
  }
}
